import {computed, ref} from "vue";

export default function () {
    const errors = ref([]);

    const hasErrors = computed(() => errors.value.some(error => !!error.length));

    function populate(data, prefix, count) {
        for (let index = 0; index < count; index++) {
            if (data[prefix + index]) {
                errors.value.push(data[prefix + index]);
            } else {
                errors.value.push([]);
            }
        }
    }

    function clear() {
        errors.value = [];
    }

    return {
        errors,
        hasErrors,
        populate,
        clear,
    };
}
